// AUTOGENERATED: DO NOT EDIT

import { AnimatedSprite, Spritesheet, SpritesheetData, Texture } from "pixi.js";
import img from "../../assets/img/tile/water.png";
import { SpriteSheetJSON } from "./type";

const data: SpriteSheetJSON = {
  frames: {
    "water 0.aseprite": {
      frame: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 1.aseprite": {
      frame: {
        x: 16,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 2.aseprite": {
      frame: {
        x: 32,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 3.aseprite": {
      frame: {
        x: 48,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 4.aseprite": {
      frame: {
        x: 64,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 5.aseprite": {
      frame: {
        x: 80,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 6.aseprite": {
      frame: {
        x: 96,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 7.aseprite": {
      frame: {
        x: 112,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 8.aseprite": {
      frame: {
        x: 128,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 9.aseprite": {
      frame: {
        x: 144,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 10.aseprite": {
      frame: {
        x: 160,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 11.aseprite": {
      frame: {
        x: 176,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 12.aseprite": {
      frame: {
        x: 192,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 13.aseprite": {
      frame: {
        x: 208,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 14.aseprite": {
      frame: {
        x: 224,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
    "water 15.aseprite": {
      frame: {
        x: 240,
        y: 0,
        w: 16,
        h: 16,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 16,
        h: 16,
      },
      sourceSize: {
        w: 16,
        h: 16,
      },
      duration: 100,
    },
  },
  meta: {
    app: "https://www.aseprite.org/",
    version: "1.3.9.2-arm64",
    image: "water.png",
    format: "RGBA8888",
    size: {
      w: 256,
      h: 16,
    },
    scale: "1",
    frameTags: [],
    layers: [
      {
        name: "Layer 1",
        opacity: 255,
        blendMode: "normal",
      },
    ],
    slices: [],
  },
  animations: {
    anim: [
      "water 0.aseprite",
      "water 1.aseprite",
      "water 2.aseprite",
      "water 3.aseprite",
      "water 4.aseprite",
      "water 5.aseprite",
      "water 6.aseprite",
      "water 7.aseprite",
      "water 8.aseprite",
      "water 9.aseprite",
      "water 10.aseprite",
      "water 11.aseprite",
      "water 12.aseprite",
      "water 13.aseprite",
      "water 14.aseprite",
      "water 15.aseprite",
    ],
  },
};
export const water = async () => {
  const texture = Texture.from(img);
  texture.source.scaleMode = "nearest";

  const spritesheet = new Spritesheet(texture, data as SpritesheetData);

  await spritesheet.parse();

  const anim = new AnimatedSprite(spritesheet.animations.anim);

  anim.width = 32;
  anim.height = 32;
  anim.anchor.set(0.5, 0.5);

  return anim;
};
